/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.piesync.bridge.rpc.ConnectionsRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const PredicateTrieCategoryInternalNodeTypename = 'com.hubspot.piesync.bridge.core.models.connection.rule.predicate.PredicateTrieCategoryInternalNode';
export const PredicateTrieCategoryInternalNodeDiscriminant = 'category';
export const PredicateTrieCategoryInternalNodeDiscriminantKey = 'type';
export const PredicateTrieCategoryLeafNodeTypename = 'com.hubspot.piesync.bridge.core.models.connection.rule.predicate.PredicateTrieCategoryLeafNode';
export const PredicateTrieCategoryLeafNodeDiscriminant = 'categoryLeaf';
export const PredicateTrieCategoryLeafNodeDiscriminantKey = 'type';
export const PredicateTrieLeafNodeTypename = 'com.hubspot.piesync.bridge.core.models.connection.rule.predicate.PredicateTrieLeafNode';
export const PredicateTrieLeafNodeDiscriminant = 'leaf';
export const PredicateTrieLeafNodeDiscriminantKey = 'type';
export const PredicateTrieNodeDiscriminantKey = 'type';

/**
 *  @deprecated use ConnectionDatasetConfiguration instead
 */

export let ComHubspotPiesyncBridgeCoreModelsConnectionScope;
(function (_ComHubspotPiesyncBridgeCoreModelsConnectionScope) {})(ComHubspotPiesyncBridgeCoreModelsConnectionScope || (ComHubspotPiesyncBridgeCoreModelsConnectionScope = {}));
export let ComHubspotPiesyncBridgeCoreModelsDatasetparameter;
(function (_ComHubspotPiesyncBridgeCoreModelsDatasetparameter) {})(ComHubspotPiesyncBridgeCoreModelsDatasetparameter || (ComHubspotPiesyncBridgeCoreModelsDatasetparameter = {}));
export let ComHubspotPiesyncBridgeModelsConnectionAbstractActivateConnectionError;
(function (_ComHubspotPiesyncBridgeModelsConnectionAbstractActivateConnectionError) {})(ComHubspotPiesyncBridgeModelsConnectionAbstractActivateConnectionError || (ComHubspotPiesyncBridgeModelsConnectionAbstractActivateConnectionError = {}));
export let ComHubspotPiesyncBridgeModelsConnectionAbstractCreateConnectionError;
(function (_ComHubspotPiesyncBridgeModelsConnectionAbstractCreateConnectionError) {})(ComHubspotPiesyncBridgeModelsConnectionAbstractCreateConnectionError || (ComHubspotPiesyncBridgeModelsConnectionAbstractCreateConnectionError = {}));
export let ComHubspotPiesyncBridgeModelsConnectionAbstractCreateConnectionsError;
(function (_ComHubspotPiesyncBridgeModelsConnectionAbstractCreateConnectionsError) {})(ComHubspotPiesyncBridgeModelsConnectionAbstractCreateConnectionsError || (ComHubspotPiesyncBridgeModelsConnectionAbstractCreateConnectionsError = {}));
export let ComHubspotPiesyncBridgeModelsConnectionAbstractUpdateConnectionError;
(function (_ComHubspotPiesyncBridgeModelsConnectionAbstractUpdateConnectionError) {})(ComHubspotPiesyncBridgeModelsConnectionAbstractUpdateConnectionError || (ComHubspotPiesyncBridgeModelsConnectionAbstractUpdateConnectionError = {}));
export let ComHubspotPiesyncBridgeModelsTriggerAbstractTriggerConnectionsError;
(function (_ComHubspotPiesyncBridgeModelsTriggerAbstractTriggerConnectionsError) {})(ComHubspotPiesyncBridgeModelsTriggerAbstractTriggerConnectionsError || (ComHubspotPiesyncBridgeModelsTriggerAbstractTriggerConnectionsError = {}));
export const getConnectionRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'getConnection',
  auth: 'app',
  fingerprint: 'IyYTGKl67DJipSNv5HMTGJMIbI95Uzou',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSummarizedConnectionRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'getSummarizedConnection',
  auth: 'app',
  fingerprint: 'fpiixki0uUMjdJ1aoBewkYn9nwvlVWOw',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const triggerConnectionsRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'triggerConnections',
  auth: 'app',
  fingerprint: 'RxKswdXA9rWDWCfh9GEnLaJblhvdd1Xf',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const refreshUpstreamDataRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'refreshUpstreamData',
  auth: 'app',
  fingerprint: '1iAuv6ghx5JbdbQ0_-TZaT65uCAbgGe5',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const pollRefreshRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'pollRefresh',
  auth: 'app',
  fingerprint: 'dJkcm-fWdmq_lyOX4yBF2Lt7JLTIJGBP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const disableConnectionRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'disableConnection',
  auth: 'app',
  fingerprint: 'qQIy7z0gAPNeWfDCAeon5kVEk6htAQTb',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const enableConnectionRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'enableConnection',
  auth: 'app',
  fingerprint: 'hdThjnYqpHuxjAOHmbKrp88dZSvKOHjM',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listLatestConnectionLifecycleEventsRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'listLatestConnectionLifecycleEvents',
  auth: 'app',
  fingerprint: 'o-kofkEGC0De4uRohhbdQmWasqdt2LfV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOverviewRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'getOverview',
  auth: 'app',
  fingerprint: 'SZXTLNb3kIwmS_g96qz7r1QzTe2G354E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSyncsNeedingAttentionRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'getSyncsNeedingAttention',
  auth: 'app',
  fingerprint: 'PZLvWE5iD2JRnCO_bKYA1pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createConnectionRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'createConnection',
  auth: 'app',
  fingerprint: 'AhxsaHFG_XnuChuJD9Gs5PNJjt0b9wzB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createConnectionsRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'createConnections',
  auth: 'app',
  fingerprint: 'lZmARJLLXjADn2tY8XaNQKU3xpgF3eLi',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const activateConnectionRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'activateConnection',
  auth: 'app',
  fingerprint: '5OY8mZJJTeO6X77ruMcfpY-fREnGT8-6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateConnectionRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'updateConnection',
  auth: 'app',
  fingerprint: 'MSBXcXbDm3EWPYKPRGFTjtn7Mbx8ZbPg',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateConnectionSettingsRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'updateConnectionSettings',
  auth: 'app',
  fingerprint: 'PQBkvf1ftJ2ClpXvQkwNo7fZQgZMHLD3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteConnectionRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'deleteConnection',
  auth: 'app',
  fingerprint: 'zc70DGkB_ZK5RB9hkI9XzF2SnWGOEd3S',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHubSpotFieldRankingsRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'getHubSpotFieldRankings',
  auth: 'app',
  fingerprint: 'ikd-uXO2GE9pB5OciFQUdckfu8lbg9wj',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const triggerHubSpotFieldRankingsRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'triggerHubSpotFieldRankings',
  auth: 'app',
  fingerprint: 'KWCpAnj_rlxzZmAlOXKeX8V0ww3gmKiC',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const pollHubSpotFieldRankingsRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'pollHubSpotFieldRankings',
  auth: 'app',
  fingerprint: 'CFyF0XHtDQJFF07RYJPUpgcrNcE9qAOh',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const activateConnectionsRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'activateConnections',
  auth: 'app',
  fingerprint: 'nNK_OfVL3mZnWQyjgGKwo5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const enableConnectionsRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'enableConnections',
  auth: 'app',
  fingerprint: 'the6qjtIsYE3LRhyYlFJz5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const disableConnectionsRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'disableConnections',
  auth: 'app',
  fingerprint: 'cqcAqfwIoLLPRfW7lbab8JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};